import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import type { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import type { NavigationMenuIdentity, Route } from '../../../components/common/mygame/menu/menu-interface'

export interface AllJobsViewsDto {
  id: number
  label: string
  route: IAllJobsViewsRouteDto[]
  editable: boolean
  default: boolean
  order: number
}

export interface IAllJobsViewsRouteDto {
  index: number
  label: string
  type: string
}

export const QUERY_KEY_JOBS_VIEWS = 'get-jobs-views'

const getMenuData = async (): Promise<AllJobsViewsDto[]> => {
  return await axios
    .get('/navigation_menu')
    .then(response => response.data)
    .then(res => {
      res.sort((a: NavigationMenuIdentity, b: NavigationMenuIdentity) => a.order - b.order)
      return res
    })
    .then(r => {
      r.forEach((item: NavigationMenuIdentity) => {
        return item.route.sort((a: Route, b: Route) => a.index - b.index)
      })
      return r
    })
}

export const useApiMenuGetAllJobsViews = (options: UseQueryOptionsWithoutQueryKey<AllJobsViewsDto[]> = {}) => {
  return useQuery<AllJobsViewsDto[]>({
    queryKey: [QUERY_KEY_JOBS_VIEWS],
    queryFn: () => getMenuData(),
    staleTime: Infinity,
    ...options
  })
}
